<template>
  <admin-wrapper hide-title-padding title-translation-path="admin.libraryKeys" :inputs="inputs[appKind]">
    <template #top>
      <v-row no-gutters class="pb-5">
        <v-col cols="12" class="text-left">
          <i18n
            :path="appKind === 'aquagis' ? 'admin.libraryKeysSubtitle' : 'admin.libraryKeysZDMSubtitle'"
            tag="span"
            class="text-caption font-italic font-weight-light pa-0"
            style="height: auto; line-height: 1rem !important; color: inherit"
          >
            <template #link>
              <a target="_blank" :href="computedUrl">{{ $i18n.t('admin.libraryKeysInstruction') }}</a>
            </template>
          </i18n>
        </v-col>
      </v-row>
    </template>
  </admin-wrapper>
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'LibraryKeysSettngs',
  components: { AdminWrapper },
  computed: {
    appKind() {
      return process.env.VUE_APP_APP_KIND || 'aquagis';
    },
    computedUrl() {
      return this.docksUrls[this.appKind];
    },
    docksUrls() {
      return {
        aquagis:
          'https://dokumentacja.aquagis.pl/knowledge-base/aquagis-dokumentacja-uzytkownika/generowanie-kluczy-do-bibliotek-aplikacji-mobilnej/',
        zdm:
          'https://docs.ils-system.eu/knowledge-base/aquagis-dokumentacja-uzytkownika/generowanie-kluczy-do-bibliotek-aplikacji-mobilnej/',
      };
    },
    inputs() {
      return {
        aquagis: [
          {
            name: 'mapbox_token',
            translationPath: 'admin.mapbox_token',
            subtitle: 'admin.mapbox_tokenSubtitle',
            dense: true,
            clearable: true,
            dataType: {
              name: 'text',
            },
            inputCols: '9',
            rules: [v => !!v || 'rules.required'],
          },
          {
            name: 'onesignal_api_key',
            translationPath: 'admin.onesignal_api_key',
            subtitle: 'admin.onesignal_api_keySubtitle',
            clearable: true,
            dense: true,
            dataType: {
              name: 'text',
            },
            inputCols: '9',
            rules: [v => !!v || 'rules.required'],
          },
          {
            name: 'onesignal_rest_api_key',
            translationPath: 'admin.onesignal_rest_api_key',
            subtitle: 'admin.onesignal_rest_api_keySubtitle',
            dense: true,
            clearable: true,
            dataType: {
              name: 'text',
            },
            inputCols: '9',
            rules: [v => !!v || 'rules.required'],
          },
        ],
        zdm: [
          {
            name: 'zdm_mapbox_token',
            translationPath: 'admin.mapbox_token',
            subtitle: 'admin.mapbox_tokenSubtitle',
            outlined: true,
            dense: true,
            clearable: true,
            dataType: {
              name: 'text',
            },
            inputCols: '9',
            rules: [v => !!v || 'rules.required'],
          },
        ],
      };
    },
  },
};
</script>
